/**
 * @file button.component.tsx
 * @description Компонент обертка для работы @consta/uikit/Button с переопределенным свойством size по умолчанию.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [react, @consta/uikit/Button]
 */

import { Button as ConstaButton } from '@consta/uikit/Button';
import { ComponentProps } from 'react';

/**
 * Props для компонента Button с кастомизированным размером по умолчанию
 */
interface IButtonProps extends ComponentProps<typeof ConstaButton> {
    /** Размер кнопки, по умолчанию 's' (small) */
    size?: 's' | 'm' | 'xs' | 'l' | undefined;
}

export const Button = ({ size = 's', ...props }: IButtonProps) => {
    return <ConstaButton size={size} {...props} />;
};
